import { SortDefinition } from '@shared/models/sort-definition';

export interface ReferentielState {
  selectedEquipeResponsable: string | null;
  paginator: { pageNb: number; pageSize: number };
  filtres: {
    equipeResponsable?: string;
    idMetier?: string;
    publicsCibles?: string[];
  } | null;
  sort: SortDefinition;
}

export const initialState: ReferentielState = {
  paginator: { pageNb: 1, pageSize: 20 },
  filtres: {},
  sort: { direction: '+', nom: 'nom' },
  selectedEquipeResponsable: null,
};
